import * as Yup from 'yup';
import type { EvRelationshipOfferings } from '@hooks/useEvBundleOfferings/useEvBundleOfferings';

export const buildValidationSchema = (groups: EvRelationshipOfferings[]) =>
  Yup.object(
    Object.fromEntries(
      groups
        .filter((g) => g.minSelect > 0)
        .map((g) => [
          g.relationship.id,
          Yup.array()
            .of(Yup.string().required())
            .min(
              g.minSelect,
              `Please select at least ${g.minSelect} option${g.minSelect > 1 ? 's' : ''} from "${g.relationship.name}"`
            ),
        ])
    )
  );
